import { register } from "@rill/loader";
import { removeQueryParams } from "../utils/widgets";

register(
  {
    name: "widgets",
    meta: ["no-bust", "widget"],
    ttl: "2 hours",
  },
  async ({ api }) => {
    const query = {
      limit: false,
    };

    const res = await api("widget", { query });
    const data = await res.json();
    return data;
  }
);

register(
  {
    name: "widgetsOrganization",
    meta: ["no-bust", "widget"],
    ttl: "2 hours",
  },
  async ({ api }) => {
    const res = await api("widget-organization");
    const data = await res.json();
    const { widgets = [] } = data;
    return widgets;
  }
);

register(
  {
    name: "recipes",
    meta: ["no-bust", "recipe"],
    ttl: "2 hours",
  },
  async ({ api }, { widget }) => {
    const query = {
      widget,
      limit: false,
      sort: { order: 1 },
    };

    const res = await api("recipe", { query });
    const data = await res.json();
    return data;
  }
);

register(
  {
    name: "widgetStores",
    meta: ["no-bust", "store"],
    ttl: "2 hours",
  },
  async ({ api }, { widget }) => {
    const query = {
      widget,
      limit: false,
      sort: { order: 1 },
    };

    const res = await api("widget-store", { query });
    const data = await res.json();
    return data;
  }
);

register(
  {
    name: "videoPlaylists",
    meta: ["no-bust", "video-playlist"],
    ttl: "2 hours",
  },
  async ({ api }, { widget }) => {
    const query = {
      widget,
      limit: false,
      sort: { order: 1 },
    };

    const res = await api("video-playlist", { query });
    const data = await res.json();
    return data;
  }
);

register(
  {
    name: "macroCalculator",
    meta: ["no-bust", "macro-calculator"],
    ttl: "2 hours",
  },
  async ({ api }, { widget }) => {
    const query = {
      widget,
      limit: false,
    };

    const res = await api("macro-calculator", { query });
    const data = await res.json();
    return data && data[0];
  }
);

register(
  {
    name: "widgetLinks",
    meta: ["no-bust", "links"],
    ttl: "2 hours",
  },
  async ({ api }, { widget }) => {
    const query = {
      widget,
      limit: false,
    };

    const res = await api("widget-link", { query });
    const data = await res.json();
    return data;
  }
);

register(
  {
    name: "widgetFiles",
    meta: ["no-bust", "file-documents"],
    ttl: "2 hours",
  },
  async ({ api }, { widget }) => {
    const query = {
      widget,
      limit: false,
    };

    const res = await api("widget-file-document", { query });
    const data = await res.json();
    return data;
  }
);

register(
  {
    name: "widgetLinkThumbnail",
    meta: ["widgetLinkThumbnail"],
  },
  async ({ api }, { url }) => {
    if (!url) return {};
    try {
      //remove query params to avoid errors in the request
      const urlWithoutQueryParams = removeQueryParams(url);
      const response = await (
        await api(`widget-link-thumbnail?url=${urlWithoutQueryParams}`)
      ).json();
      const data = response.thumbnail ? response.thumbnail : "unavailable";
      return data;
    } catch (_) {}
  }
);

register(
  {
    name: "mealPlanLibraries",
    meta: ["no-bust", "meal-plan-library"],
    ttl: "2 hours",
  },
  async ({ api }, { widget }) => {
    const query = {
      widget,
      limit: false,
    };

    const res = await api("meal-plan-library", { query });
    const data = await res.json();
    return data;
  }
);

register(
  {
    name: "dailyAccountabilityTemplates",
    meta: ["no-bust", "daily-accountability-template"],
    ttl: "2 hours",
  },
  async ({ api }, { widget }) => {
    const query = {
      widget,
      limit: false,
    };

    const res = await api("widget-daily-accountability-template", { query });
    const data = await res.json();
    return data;
  }
);

register(
  {
    name: "dailyAccountabilityTemplate",
    meta: ["no-bust", "daily-accountability-template"],
    ttl: "2 hours",
  },
  async ({ api }, { templateId }) => {
    const res = await api(`widget-daily-accountability-template/${templateId}`);
    const data = await res.json();
    return data;
  }
);
